export default __webpack_public_path__ + "static/media/pip.9eea82ab.png";